<template>
    <div class="rfq" >
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm">
                    <el-form-item label="客户公司">
                        <el-select v-model="searchForm.customerId" placeholder="请选择客户公司" :loading="unitsLoading" clearable filterable size="mini" style="width: 230px;">
                            <el-option
                                v-for="item in customers"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="SKU">
                        <el-input v-model="searchForm.sku" placeholder="请输入SKU" clearable size="mini" style="width: 230px;" @keyup.enter.native="() => {this.currentPage=1;onSearch();}"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    :data="tableData"
                    v-loading="loading"
                    :max-height="tableHeight"
                    @selection-change="handleSelectionChange"
                    style="width: 100%">
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column prop="customer" label="公司名称" width="180"></el-table-column>
                    <el-table-column prop="sku" label="SKU" width="100"></el-table-column>
                    <el-table-column prop="spu" label="推送SPU" width="100"></el-table-column>
                    <el-table-column prop="customerMaterialCode" label="物料号" width="120"></el-table-column>
                    <el-table-column prop="name" label="商品名称"></el-table-column>
                    <el-table-column prop="brand" label="商品品牌" width="180"></el-table-column>
                    <el-table-column prop="supplierUntaxedPrice" label="采购未税价格" width="120"></el-table-column>
                    <el-table-column prop="supplierPrice" label="采购含税税价格" width="120"></el-table-column>
                    <el-table-column prop="untaxedPrice" label="销售未税价格" width="120"></el-table-column>
                    <el-table-column prop="price" label="销售含税税价格" width="120"></el-table-column>
                    <el-table-column prop="profitMargin" label="利润率(%)" width="100">
                        <template slot-scope="scope">
                            {{ ((scope.row.price - scope.row.supplierPrice) * 100 / scope.row.supplierPrice).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="商品状态" width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 1" size="mini">已上架</el-tag>
                            <el-tag v-if="scope.row.status === 0" size="mini" type="info">已下架</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pushStatus" label="推送状态" width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.pushStatus === 1" size="mini">已推送</el-tag>
                            <el-tag v-if="scope.row.pushStatus === 0" size="mini" type="warning">等待推送</el-tag>
                            <el-tooltip v-if="scope.row.pushStatus === 2" :content="scope.row.message" placement="top">
                                <el-tag size="mini" type="danger">推送失败</el-tag>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="200" align="right" fixed="right">
                        <template slot="header" slot-scope="header">
                            <el-button type="primary" size="mini" @click="handleShowPushProductDialog()">推送商品</el-button>

                            <el-dropdown style="margin-left: 4px" @command="more">
                                <el-button type="primary" size="mini">
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown" @command="more">
                                    <el-dropdown-item command="many">批量推送
                                    </el-dropdown-item>
                                    <el-dropdown-item command="template">
                                        <a :href="pushProductTemplateUrl" style="margin-right:16px">批量推送模板</a>
                                    </el-dropdown-item>
<!--                                    <el-dropdown-item command="many">批量导入</el-dropdown-item>-->
                                    <el-dropdown-item command="materialCode">补充物料号</el-dropdown-item>
                                    <el-dropdown-item command="putOn">批量上架</el-dropdown-item>
                                    <el-dropdown-item command="pullOff">批量下架</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <el-button type="primary" size="mini" @click="handlePushAll()">批量推送</el-button> -->
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleShowUpdatePriceDialog(scope.row)">修改价格</el-button>
                            <!-- <el-button v-if="scope.row.status === 0" type="text" size="mini" @click="handlePutOn(scope.row)">上架</el-button>
                            <el-button v-if="scope.row.status === 1" type="text" size="mini" @click="handlePullOff(scope.row)">下架</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        stripe
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="推送新商品" :visible.sync="pushProductDialogVisible" width="1200px" :close-on-click-modal="false">
            <el-form ref="searchProductForm" :inline="true" :model="searchProductForm" :rules="searchProductFormRules" label-width="90px">
                <el-form-item label="供应商" prop="supplierId" size="mini">
                    <el-select v-model="searchProductForm.supplierId" placeholder="请选择供应商" clearable>
                        <el-option
                            v-for="item in suppliers"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="查询内容" prop="searchKey" size="mini">
                    <el-input v-model="searchProductForm.searchKey" placeholder="请输入SKU或商品名称1" @keyup.enter.native="onSearchProduct()" clearable></el-input>
                </el-form-item>
                <el-button type="primary" @click="onSearchProduct()" size="mini">查询</el-button>
            </el-form>
            <el-table
                size="mini"
                height="200"
                ref="tableProductData"
                :data="tableProductData"
                v-loading="productDataLoading"
                highlight-current-row
                @row-click="selectProduct"
                style="width: 100%">
                <el-table-column prop="sku" label="SKU" width="100"></el-table-column>
                <el-table-column prop="shotName" label="商品简称" width="80"></el-table-column>
                <el-table-column prop="productName" label="商品名称"></el-table-column>
                <el-table-column prop="brand" label="商品品牌" width="80"></el-table-column>
                <el-table-column prop="unit" label="销售单位" width="70"></el-table-column>
                <el-table-column prop="moq" label="最小起订量" width="80"></el-table-column>
                <el-table-column prop="supplierUntaxedPrice" label="采购未税" width="80"></el-table-column>
                <el-table-column prop="supplierPrice" label="采购含税" width="80"></el-table-column>
                <el-table-column prop="untaxedPrice" label="销售未税" width="80"></el-table-column>
                <el-table-column prop="price" label="销售含税" width="80"></el-table-column>
                <el-table-column prop="officialPrice" label="面价" width="80"></el-table-column>
                <el-table-column prop="supplier" label="供应商" width="180"></el-table-column>
            </el-table>
            <el-divider></el-divider>
            <el-descriptions title="商品信息" style="padding: 0 20px">
                <el-descriptions-item label="SKU">{{ selectedProduct.sku }}</el-descriptions-item>
                <el-descriptions-item label="商品名称" span="2">{{ selectedProduct.productName }}</el-descriptions-item>
                <el-descriptions-item label="商品简称">{{ selectedProduct.shortName }}</el-descriptions-item>
                <el-descriptions-item label="商品品牌">{{ selectedProduct.brand }}</el-descriptions-item>
                <el-descriptions-item label="销售单位">{{ selectedProduct.unit }}</el-descriptions-item>
                <el-descriptions-item label="采购未税价格">{{ selectedProduct.supplierUntaxedPrice }}</el-descriptions-item>
                <el-descriptions-item label="采购含税税价格">{{ selectedProduct.supplierPrice }}</el-descriptions-item>
                <el-descriptions-item label="面价">{{ selectedProduct.officialPrice }}</el-descriptions-item>
                <el-descriptions-item label="最小起订量">{{ selectedProduct.moq }}</el-descriptions-item>
                <el-descriptions-item label="供应商" span="2">{{ selectedProduct.supplier }}</el-descriptions-item>
            </el-descriptions>
            <el-divider>推送商品信息配置</el-divider>
            <el-form ref="pushProductForm" :inline="true" :model="pushProductForm" :rules="pushProductFormRules" label-width="90px">
                <el-row>
                    <el-form-item label="客户公司" prop="customer" size="mini">
                        <el-select v-model="pushProduct.customer" placeholder="请选择客户公司" :loading="unitsLoading" clearable filterable style="width: 230px;">
                            <el-option
                                v-for="item in customers"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="SKU" prop="sku" size="mini">
                        <el-input v-model="pushProduct.sku" disabled style="width: 230px;" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="品牌" prop="brand" size="mini">
                        <el-select v-model="pushProduct.brand" placeholder="请选择品牌" :loading="unitsLoading" clearable filterable style="width: 230px;">
                            <el-option
                                v-for="item in brands"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="京采云类目" prop="categoryId" size="mini">
                        <el-cascader
                            v-model="categoryPath"
                            :options="jcyCategories"
                            :props="categoryCascaderProps"
                            :loading="categoriesLoading"
                            filterable
                            clearable
                            placeholder="请选择京采云类目（须选到三级）"
                            style="width: 460px;"
                            @change="handleCategoryChange">
                        </el-cascader>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="商品名称" prop="name" size="mini">
                        <el-radio-group v-model="pushProduct.name">
                            <el-radio :label="pushProduct.productName"></el-radio>
                            <el-radio :label="pushProduct.shortName"></el-radio>
                            <el-radio label="自定义"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="pushProduct.name === '自定义'" label="" prop="customName" size="mini">
                        <el-input v-model="pushProduct.customName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品面价" prop="officialPrice" size="mini">
                        <el-input v-model="pushProduct.officialPrice" clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-row>
                <!-- <el-row>
                    <el-form-item label="销售单位" prop="unit" size="mini">
                        <el-select v-model="pushProduct.unit" placeholder="请选择销售单位" :loading="unitsLoading" clearable filterable style="width: 230px;">
                            <el-option
                                v-for="item in units"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品面价" prop="officialPrice" size="mini">
                        <el-input v-model="pushProduct.officialPrice" clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-row> -->
                <el-row>
                    <el-form-item label="含税售价" prop="price" size="mini">
                        <el-input v-model="pushProduct.price" clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="税率" prop="tax" size="mini">
                        <el-input v-model="pushProduct.tax" clearable>
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="未税售价" size="mini">
                        <el-input v-model="untaxedPrice" disabled clearable>
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pushProductDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handlePush" :disabled="!canPush" size="small">推 送</el-button>
            </div>
        </el-dialog>
        <el-dialog title="更新商品价格" :visible.sync="updatePriceDialogVisible" width="400px" :close-on-click-modal="false">
            <el-form ref="updatePriceForm" :model="updatePriceForm" :rules="updatePriceFormRules" label-width="90px">
                <el-row>
                    <el-form-item label="SKU" prop="sku" size="mini">
                        <el-input v-model="updatePriceForm.sku" disabled clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="商品名称" prop="name" size="mini">
                        <el-input v-model="updatePriceForm.name" disabled clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="商品面价" prop="officialPrice" size="mini">
                        <el-input v-model="updatePriceForm.officialPrice" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="销售价格" prop="price" size="mini">
                        <el-input v-model="updatePriceForm.price" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="税率" prop="tax" size="mini">
                        <el-input v-model="updatePriceForm.tax" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="未税售价" prop="newUntaxedPrice" size="mini">
                        <el-input v-model="newUntaxedPrice" disabled clearable></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updatePriceDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handleUpdatePrice" size="small">更 新</el-button>
            </div>
        </el-dialog>
        <el-dialog title="批量推送" :modal="true" :visible.sync="uploadDialogVisible" width="560px">
            <el-upload ref="upload"
                       class="upload-demo"
                       drag
                       action="/api/admin/mall/jcy/uploadPushProduct"
                       :http-request="uploadPushProductRequest"
                       :limit="1"
                       accept=".xlsx"
                       :show-file-list="true">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">请使用最新模板。必填列含「福田一级类目*」「福田二级类目*」「福田三级类目*」，填写类目名称（与京采同步后一致）。无论预检或推送，都会自动下载结果 Excel（含「推送结果」「失败原因」「福田类目ID」列）</div>
            </el-upload>
            <div v-html="uploadCheckResult" style="color:#F56C6C;margin-top:12px;line-height:1.6;word-break:break-all;"></div>
        </el-dialog>
        <el-dialog title="补充物料号" :modal="true" :visible.sync="uploadMaterialCodeDialogVisible" width="400px">
            <el-upload ref="uploadMaterialCode"
                       class="upload-demo"
                       drag
                       action="/api/admin/mall/jcy/uploadCustomerMaterialCode"
                       :limit="1"
                       accept=".xlsx"
                       :on-success="uploadMaterialCodeSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">Excel 需包含「鹏龙天创SKU」「客户物料编码」列</div>
            </el-upload>
            <div v-html="uploadMaterialCodeCheckResult"></div>
        </el-dialog>
    </div>
</template>
<script>
import { convertRes2Blob } from '@/utils/download';

// 批量推送模板更新时请递增版本号，避免浏览器缓存旧文件
const PUSH_PRODUCT_TEMPLATE_VERSION = '2025082301';

export default {

    data() {
        return {
            pushProductDialogVisible:false,
            companys:[],
            users: [],
            searchForm: {
                customerId: "",
                sku: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            editForm: {},

            searchProductForm: {},
            productDataLoading: false,
            tableProductData: [],

            pushProductForm: {},
            selectedProduct: {},
            pushProduct: {
                productName: '商品名称',
                shortName: '商品简称',
            },
            units: [],
            unitsLoading: false,

            brands: [],
            customers: [],

            jcyCategories: [],
            categoryPath: [],
            categoriesLoading: false,
            categoryCascaderProps: {
                value: 'categoryId',
                label: 'categoryName',
                children: 'children',
                leaf: 'leaf',
            },

            selectData: [],

            updatePriceDialogVisible: false,
            updatePriceForm: {},

            rules: {
                companyId: [
                    { required: true, message: '请选择客户公司', trigger: 'blur' }
                ],
                userId: [
                    { required: true, message: '请选择下单账号', trigger: 'blur' }
                ],
                supplierId: [
                    { required: true, message: '请输入供应商ID', trigger: 'blur' }
                ],
                appKey: [
                    { required: true, message: '请输入MRO账号', trigger: 'blur' }
                ],
                appSecret: [
                    { required: true, message: '请输入MRO密码', trigger: 'blur' }
                ],
                mallAppKey: [
                    { required: true, message: '请输入商城账号', trigger: 'blur' }
                ],
                mallAppSecret: [
                    { required: true, message: '请输入商城密码', trigger: 'blur' }
                ],
            },
            searchProductFormRules: {
                searchKey: [
                    { required: true, message: '请输入查询内容', trigger: 'blur' }
                ],
            },
            pushProductFormRules: {
                searchKey: [
                    { required: true, message: 'SKU不能为空', trigger: 'blur' }
                ],
            },
            updatePriceFormRules: {

            },
            uploadDialogVisible: false,
            uploadCheckResult: "",
            uploadMaterialCodeDialogVisible: false,
            uploadMaterialCodeCheckResult: "",
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this
            let cond = {...this.searchForm};

            this.$axios.post("/admin/mall/jcy/searchJcyProduct",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            }).finally(() => {
                _this.loading = false;
            });
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        loadSuppliers(){
            const that = this;
            this.$axios.get("/admin/supplier/loadSuppliers"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.suppliers = resp.data;
                }
            });
        },
        onSearchProduct() {
            let that = this;
            this.$refs.searchProductForm.validate(valid => {
                if(valid) {
                    that.tableProductData = [];
                    that.selectedProduct = {};
                    this.productDataLoading = true;
                    this.$axios.post("/admin/mall/jcy/searchProduct",{...this.searchProductForm})
                    .then(function(response) {
                        let resp = response.data;
                        if( resp.header.status == 0) {
                            that.tableProductData = resp.data;
                        }
                    }).catch(function() {
                    }).finally(() => {
                        that.productDataLoading = false;
                    });
                }
            });
        },
        selectProduct(row) {
            this.$refs.tableProductData.setCurrentRow(row);
            this.selectedProduct=row;
            this.pushProduct={
                ...row,
                tax: 13,
                unit: null,
                brand: null,
                categoryId: null,
            };
            this.categoryPath = [];
            const that = this;
            const prefillCategory = () => that.prefillCategoryFromRow(row);
            if (that.jcyCategories.length) {
                prefillCategory();
            } else {
                that.loadCategories().then(prefillCategory);
            }
            if(row['sku']) {
                this.unitsLoading = true;
                this.$axios.get(`/admin/mall/jcy/loadCategoryUnits/${row['sku']}`)
                .then(function(response) {
                    let resp = response.data;
                    if( resp.header.status == 0) {
                        that.units = resp.data;
                        const newPushProduct = {...that.pushProduct};
                        const validUnits = that.units.filter(u => u['value'] === row['unit']);
                        if(validUnits.length > 0) {
                            newPushProduct['unit'] = validUnits[0].key;
                            // that.pushProduct = {
                            //     ...that.pushProduct,
                            //     unit: validUnits[0].key,
                            // }
                        }
                        const validBrands = that.brands.filter(b => b['value'] === row['brandd']);
                        if(validBrands.length > 0) {
                            newPushProduct['brand'] = validBrands[0].key;
                        }
                        that.pushProduct = {...newPushProduct};
                    }
                }).catch(function() {
                }).finally(() => {
                    that.productDataLoading = false;
                    that.unitsLoading = false;
                });
            }
        },
        handleShowPushProductDialog() {
            this.pushProductDialogVisible = true;
            this.searchProductForm = {};
            this.tableProductData = [];
            this.pushProductForm = {};
            this.selectedProduct = {};
            this.pushProduct = {
                productName: '商品名称',
                shortName: '商品简称',
            };
            this.units = [];
            this.categoryPath = [];
            this.loadCategories();
        },
        handlePush() {
            const message = [];
            const salePrice = Number(this.pushProduct.price);
            const supplierPrice = Number(this.selectedProduct.supplierPrice);
            const officialPrice = Number(this.selectedProduct.officialPrice);
            if(Number.isFinite(salePrice) && Number.isFinite(supplierPrice) && salePrice < supplierPrice) {
                message.push("销售价格小于采购价格");
            }
            if(Number.isFinite(salePrice) && Number.isFinite(officialPrice) && salePrice > officialPrice) {
                message.push(salePrice+"+销售价格大于面价"+officialPrice);
            }
            if(message.length > 0) {
                this.$confirm(`${message.join(' 且 ')}，确定推送?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.onPushProduct();
                });
            } else {
                this.onPushProduct();
            }
        },
        onPushProduct() {
            const {customer, sku, name, customName, brand, unit, tax, price, officialPrice, categoryId} = this.pushProduct;
            const that = this;
            this.$axios.post('/admin/mall/jcy/pushProduct', {
                customer, sku, productName: name === '自定义' ? customName : name, brand, unit, officialPrice, price, tax, categoryId,
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status === 0) {
                    that.onSearch();
                    that.pushProductDialogVisible = false;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            }).catch(function() {
            }).finally(() => {
            });
        },
        handlePushAll() {},
        handleShowUpdatePriceDialog(row) {
            this.updatePriceForm = {
                ...row,
                tax: row.tax * 100,
            };
            this.updatePriceDialogVisible = true;
        },
        handleUpdatePrice() {
            const that = this;
            const {id, officialPrice, price, tax} = this.updatePriceForm;
            this.$axios.post('/admin/mall/jcy/updatePrice', {id, officialPrice, price, tax})
            .then(function(response) {
                let resp = response.data;
                if( resp.header.status === 0) {
                    that.onSearch();
                    that.updatePriceDialogVisible = false;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        loadBrands() {
            const that = this;
            this.$axios.get("/admin/mall/jcy/loadBrands"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.brands = resp.data;
                }
            });
        },
        loadCustomers() {
            const that = this;
            this.$axios.get("/admin/mall/jcy/loadCustomers"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.customers = resp.data;
                }
            });
        },
        loadCategories() {
            if (this.jcyCategories.length) {
                return Promise.resolve();
            }
            const that = this;
            that.categoriesLoading = true;
            return this.$axios.get('/admin/mall/jcy/loadCategories')
            .then(function(response) {
                const resp = response.data;
                if (resp.header.status == 0) {
                    that.jcyCategories = that.normalizeJcyCategories(resp.data || []);
                    if (!that.jcyCategories.length) {
                        that.$message.warning('京采云类目为空，请先执行类目同步');
                    }
                }
            }).catch(function() {
            }).finally(() => {
                that.categoriesLoading = false;
            });
        },
        normalizeJcyCategories(nodes) {
            if (!nodes || !nodes.length) {
                return [];
            }
            return nodes.map(node => {
                const item = {
                    categoryId: Number(node.categoryId),
                    categoryName: node.categoryName,
                    categoryLevel: node.categoryLevel,
                };
                const children = node.children;
                if (node.categoryLevel >= 3 || !children || !children.length) {
                    item.leaf = true;
                } else {
                    item.children = this.normalizeJcyCategories(children);
                }
                return item;
            });
        },
        findCategoryPath(nodes, targetId, path = []) {
            if (!nodes || !nodes.length) {
                return null;
            }
            const target = Number(targetId);
            for (const node of nodes) {
                const currentPath = [...path, node.categoryId];
                if (Number(node.categoryId) === target) {
                    return currentPath;
                }
                if (node.children && node.children.length) {
                    const childPath = this.findCategoryPath(node.children, target, currentPath);
                    if (childPath) {
                        return childPath;
                    }
                }
            }
            return null;
        },
        prefillCategoryFromRow(row) {
            this.categoryPath = [];
            this.pushProduct.categoryId = null;
            const jcyCategoryId = row.jcyCategoryId;
            if (jcyCategoryId == null || jcyCategoryId === '') {
                this.$message.warning('未匹配到推荐类目，请手动选择');
                return;
            }
            const path = this.findCategoryPath(this.jcyCategories, jcyCategoryId);
            if (path && path.length === 3) {
                this.categoryPath = path;
                this.pushProduct.categoryId = path[2];
                return;
            }
            this.$message.warning('推荐类目已失效，请手动选择');
        },
        handleCategoryChange(path) {
            if (path && path.length >= 3) {
                this.pushProduct.categoryId = Number(path[path.length - 1]);
                return;
            }
            this.pushProduct.categoryId = null;
        },
        pushMany() {
            this.uploadCheckResult = "";
            this.uploadDialogVisible = true;

        },
        uploadCustomerMaterialCode() {
            this.uploadMaterialCodeCheckResult = "";
            this.uploadMaterialCodeDialogVisible = true;
        },
        more(command) {
            if(command == "many"){

                this.pushMany();
                return;
            }
            if(command == "materialCode") {
                this.uploadCustomerMaterialCode();
                return;
            }

            if(this.selectData.length === 0) {
                return;
            }
            const that = this;
            switch(command) {

                case 'putOn':
                    // this.loading = true;
                    this.$confirm('确定上架已选择商品吗？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        that.$axios.post("/admin/mall/jcy/putOn",
                            that.selectData.map(it => it['id']),
                        ).then(function (response) {
                            let resp = response.data;
                            if (resp.header.status !== 0) {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                            that.onSearch();
                        }).finally(() => {
                        });
                    });
                    break;
                case 'pullOff':
                    // this.loading = true;
                    this.$confirm('确定下架已选择商品吗？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        that.$axios.post("/admin/mall/jcy/pullOff",
                            that.selectData.map(it => it['id']),
                        ).then(function (response) {
                            let resp = response.data;
                            if (resp.header.status !== 0) {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                            that.onSearch();
                        }).finally(() => {
                        });
                    });
                    break;
                default:
                    break;
            }
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        uploadPushProductRequest({ file }) {
            this.uploadCheckResult = '';
            const formData = new FormData();
            formData.append('file', file);
            this.$axios.post('/admin/mall/jcy/uploadPushProduct', formData, {
                responseType: 'blob',
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 600000
            }).then(async (response) => {
                this.$refs.upload && this.$refs.upload.clearFiles();
                const contentType = (response.headers['content-type'] || '').toLowerCase();
                // 仅系统级异常仍可能返回 JSON；业务预检/推送结果统一为 Excel
                if (contentType.includes('application/json')) {
                    const text = await response.data.text();
                    let msg = '上传失败';
                    try {
                        const json = JSON.parse(text);
                        msg = (json.header && (json.header.msg || json.header.msg_cd)) || msg;
                    } catch (e) {
                        msg = text || msg;
                    }
                    this.uploadCheckResult = msg;
                    this.$notify({
                        title: '上传失败',
                        message: String(msg).replace(/<br\s*\/?>/gi, '；'),
                        type: 'error',
                        duration: 8000
                    });
                    return;
                }
                convertRes2Blob(response);
                this.$notify({
                    title: '完成',
                    message: '已下载结果 Excel，请查看「推送结果」「失败原因」「福田类目ID」列',
                    type: 'success',
                    duration: 5000
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            }).catch(async (err) => {
                this.$refs.upload && this.$refs.upload.clearFiles();
                let msg = '上传失败';
                try {
                    const data = err.response && err.response.data;
                    if (data instanceof Blob) {
                        const text = await data.text();
                        try {
                            const json = JSON.parse(text);
                            msg = (json.header && (json.header.msg || json.header.msg_cd)) || text;
                        } catch (e) {
                            msg = text || msg;
                        }
                    } else if (err.message) {
                        msg = err.message;
                    }
                } catch (e) {
                    // ignore
                }
                this.uploadCheckResult = msg;
                this.$notify({
                    title: '上传失败',
                    message: String(msg).replace(/<br\s*\/?>/gi, '；'),
                    type: 'error',
                    duration: 8000
                });
            });
        },
        uploadMaterialCodeSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.uploadMaterialCode.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '物料号补充成功',
                    type: 'success'
                });
                this.uploadMaterialCodeDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadMaterialCodeCheckResult = msg;
            }
        },
    },
    created() {
        this.onSearch();
        this.loadSuppliers();
        this.loadBrands();
        this.loadCustomers();
    },
    computed: {
        pushProductTemplateUrl() {
            return `/template/批量推送模板.xlsx?v=${PUSH_PRODUCT_TEMPLATE_VERSION}`;
        },
        untaxedPrice() {
            if(this.pushProduct.price && this.pushProduct.tax) {
                return (Number.parseFloat(this.pushProduct.price) * 100 / (100+Number.parseFloat(this.pushProduct.tax))).toFixed(2);
            } else {
                return "";
            }
        },
        newUntaxedPrice() {
            if(this.updatePriceForm.price && this.updatePriceForm.tax) {
                return (Number.parseFloat(this.updatePriceForm.price) * 100 / (100+Number.parseFloat(this.updatePriceForm.tax))).toFixed(2);
            } else {
                return "";
            }
        },
        canPush() {
            return ((this.pushProduct.name && this.pushProduct.name != '自定义') || this.pushProduct.customName)
            && this.pushProduct.customer
            && this.pushProduct.sku
            && this.pushProduct.brand
            && this.pushProduct.categoryId
            && this.pushProduct.price
            && this.pushProduct.untaxedPrice
            && this.pushProduct.tax;
        },
        tableHeight() {
            return this.$store.state.clientHeight - 320;
        }
    }
}
</script>
